import React, { useState, useEffect } from 'react';
import { FormControlLabel, Input, ListItem, NativeSelect } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Button from "components/CustomButtons/Button";
import { RemoveCircleOutline } from "@mui/icons-material";
import { advancedSelectOption, getItemFromName } from "variables/lists/AdvancedSearchSelectOptions";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import {withStyles} from "@mui/styles";
import advancedSearchStyle from "assets/jss/material-dashboard-pro-react/components/advancedSearchStyle";

function LineCondition(props) {

    const { obj, classes, id, type } = props;
    const [itemsCondition, setItemsCondition] = useState([]);
    const [comparator, setComparator] = useState('');
    const [option, setOption] = useState({});
    const [val, setVal] = useState('');

    useEffect(() => {
        setItemsCondition(advancedSelectOption[type].sort((a, b) => (a.item.value > b.item.value) ? 1 : -1).map(items => {
            return <option value={items.item.name} key={items.item.value}>{items.item.value}</option>;
        }));
       // console.log(obj.item);
        if (!obj.item || obj.item === '') {
            obj.item = advancedSelectOption[type][0].item.name;
            const optionnew = advancedSelectOption[type].find(opt => obj.item === opt.item.name);
            setOption(optionnew || advancedSelectOption[type][0]);
            obj.comparator = optionnew?.comparator[0].name || advancedSelectOption[type][0].comparator[0].name;
            setComparator(obj.comparator);
          //  console.log(obj.value);
            if (optionnew?.type === 'select') {
                obj.value = optionnew.value[0].id;
            }
            else {
                obj.value = '';
            }  
            obj.itemChanged = false;
        }
    }, []);

    useEffect(() => {
        const optionnew = advancedSelectOption[type].find(opt => obj.item === opt.item.name);
        setOption(optionnew || advancedSelectOption[type][0]);
        if (obj.itemChanged) {
           // console.log(obj.comparator);
            obj.comparator = optionnew?.comparator[0].name || advancedSelectOption[type][0].comparator[0].name;
            setComparator(obj.comparator);
           // console.log(obj.value);
            if (optionnew?.type === 'select') {
                obj.value = optionnew.value[0].id;
            }
            else {
                obj.value = '';
            }  
            obj.itemChanged = false;
        }
        setComparator(obj.comparator);
        setVal(obj.value);
    }, [obj.item]);

    const advancedSearchSelectOption = (value, id) => {
        const option = advancedSelectOption[type].find(opt => value === opt.item.name);
        setOption(option);
        props.handleConditionChange();
    }

    const handleOptions = (event, id) => {
        obj.item = event.target.value;
        obj.itemChanged = true;
        advancedSearchSelectOption(event.target.value, id);
    }

    const handleComparator = (event) => {
        obj.comparator = event.target.value;
        setComparator(obj.comparator);
        props.handleConditionChange();
    }

    const handleOptionValue = (event) => {
        obj.value = event.target.value;
        setVal(obj.value);
        props.handleConditionChange();
    }

    return (
        <ListItem>
            <GridContainer>
                <GridItem xs={6} md={4} lg={4}>
                    <FormControl fullWidth>
                        <NativeSelect
                            className={classes.nativeSelect}
                            inputProps={{ name: "optionsItems", id: "optionsItems" }}
                            onChange={(event) => {
                                handleOptions(event, id)
                            }}
                            value={obj?.item}
                        >
                            {itemsCondition}
                        </NativeSelect>
                    </FormControl>
                </GridItem>
                <GridItem xs={6} md={3} lg={3}>
                    <FormControl>
                        <NativeSelect inputProps={{ name: "comparator", id: "comparator" }}
                            onChange={handleComparator} key={id}
                            value={comparator}
                            className={classes.nativeSelect}
                        >
                            {
                                option?.comparator?.map(comp => {
                                    return <option value={comp.name} key={comp.name}> {comp.value} </option>
                                })
                            }
                        </NativeSelect>
                    </FormControl>
                </GridItem>
                <GridItem xs={6} md={3} lg={3}>
                    <FormControl>
                        {option?.type === 'text'  && (obj?.comparator !== 'text_isnull' && obj?.comparator !== 'text_isnotnull')?
                            <Input type={"text"}
                                name={'criteria'}
                                placeholder={"Entrez un critère "}
                                onChange={handleOptionValue}
                                className={classes.nativeSelect}
                                value={val}
                            />
                            : option?.type === 'select' ?
                                <NativeSelect
                                    className={classes.nativeSelect}
                                    inputProps={{ name: "selectValue", id: "selectValue" }}
                                    onChange={handleOptionValue}
                                    value={val}
                                >
                                    {option.value.map(val => {
                                        return <option value={val.id} key={val.id}> {val.name} </option>;
                                    })}
                                </NativeSelect>
                                : option?.type === 'number'  && (obj?.comparator !== 'number_isnull' && obj?.comparator !== 'number_isnotnull')?
                                    <Input type={"number"}
                                        name={'numberValue'}
                                        onChange={handleOptionValue}
                                        placeholder={"00.."}
                                        className={classes.nativeSelect}
                                        value={val}
                                    />
                                    : option?.type === 'date'  && (obj?.comparator !== 'date_isnull' && obj?.comparator !== 'date_isnotnull')?
                                        <Input type={"date"}
                                            name={'dateValue'}
                                            onChange={handleOptionValue}
                                            className={classes.nativeSelect}
                                            value={val}
                                        />
                                        : <></>}
                    </FormControl>
                </GridItem>
                <FormControlLabel
                    className={classes.formControlLabel}
                    value="remove"
                    control={
                        <Button
                            type="button"
                            round color="transparent" justIcon
                            size={"sm"}
                            onClick={() => props.removeCondition(id)}
                        >
                            <RemoveCircleOutline> </RemoveCircleOutline>
                        </Button>
                    }
                    labelPlacement="start"
                    label={props.whichCondition}
                />
            </GridContainer>
        </ListItem>
    );

}

export default withStyles(advancedSearchStyle)(LineCondition);

LineCondition.propTypes = {
    id: PropTypes.string,
    removeCondition: PropTypes.func,
    whichCondition: PropTypes.string,
    obj: PropTypes.object,
}

